import React from 'react';
import PropTypes from 'prop-types';
import { useSweepstakesDrawer } from '../../contexts/SweepstakesDrawerContext';
import { SweepstakesOptInDrawer } from '../../common/Drawer/SweepstakesDrawer/SweepstakesOptInDrawer';
import { SweepstakesSurveyDrawer } from '../../common/Drawer/SweepstakesDrawer/SweepstakesSurveyDrawer';
import { SweepstakesDetailsDrawer } from '../../common/Drawer/SweepstakesDrawer/SweepstakesDetailsDrawer';
import { SweepstakesStepDrawer } from '../../common/Drawer/SweepstakesDrawer/SweepstakesStepDrawer';
import { SWEEPSTAKES_CONSTANTS } from '../../core/Constants';

export const SweepstakesDrawerContainer = ({
  isLoading,
  hasError,
  onAcceptSweepstakes,
}) => {
  const {
    drawerState,
    closeDrawer,
    navigateToDrawer,
    DRAWER_TYPES,
  } = useSweepstakesDrawer();

  const { isOpen, drawerType, sweepstakesData, selectedStep } = drawerState;

  const handleTakeSurvey = () => {
    navigateToDrawer(DRAWER_TYPES.SURVEY);
  };

  const handleSurveyComplete = async () => {
    if (onAcceptSweepstakes) {
      await onAcceptSweepstakes();
    }
    closeDrawer();
  };

  const handleStepClick = (step) => {
    navigateToDrawer(DRAWER_TYPES.STEP, { selectedStep: step });
  };

  const handleStepBack = () => {
    navigateToDrawer(DRAWER_TYPES.DETAILS);
  };

  return (
    <div data-testid="sweepstakes-drawer-container">
      <SweepstakesOptInDrawer
        isOpen={isOpen && drawerType === DRAWER_TYPES.OPT_IN}
        onClose={closeDrawer}
        onTakeSurvey={handleTakeSurvey}
        heroImage={sweepstakesData?.heroImage}
        isLoading={isLoading}
        hasError={hasError}
        data-testid="sweepstakes-opt-in-drawer"
      />
      <SweepstakesSurveyDrawer
        isOpen={isOpen && drawerType === DRAWER_TYPES.SURVEY}
        onClose={closeDrawer}
        onComplete={handleSurveyComplete}
        heroImage={sweepstakesData?.heroImage}
        data-testid="sweepstakes-survey-drawer"
      />
      <SweepstakesDetailsDrawer
        isOpen={isOpen && drawerType === DRAWER_TYPES.DETAILS}
        onClose={closeDrawer}
        onStepClick={handleStepClick}
        sweepstakesData={sweepstakesData}
        isLoading={isLoading}
        hasError={hasError}
        data-testid="sweepstakes-details-drawer"
      />
      <SweepstakesStepDrawer
        isOpen={isOpen && drawerType === DRAWER_TYPES.STEP}
        onClose={closeDrawer}
        onBack={handleStepBack}
        step={selectedStep}
        allSteps={sweepstakesData?.steps}
        data-testid="sweepstakes-step-drawer"
      />
    </div>
  );
};

SweepstakesDrawerContainer.propTypes = {
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
  onAcceptSweepstakes: PropTypes.func,
};

SweepstakesDrawerContainer.defaultProps = {
  isLoading: false,
  hasError: false,
  onAcceptSweepstakes: null,
};